import { render, staticRenderFns } from "./VideoButton.vue?vue&type=template&id=b2b74bd8"
import script from "./VideoButton.vue?vue&type=script&lang=js"
export * from "./VideoButton.vue?vue&type=script&lang=js"
import style0 from "./VideoButton.vue?vue&type=style&index=0&id=b2b74bd8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports